import { ExemptionMotiveType } from "models/ExemptionMotiveType";
import { ObjectWithAnyValues } from "utils/types";
import { BaseServices } from "./baseServices";

export class ExemptionMotiveTypeService extends BaseServices<ObjectWithAnyValues, ExemptionMotiveType> {
	static instance = new ExemptionMotiveTypeService();
	static readonly baseEndpoint = "/exemption-motive-types";

	constructor() {
		super(ExemptionMotiveType);
	}

	async listExemptionMotiveTypes(exemptionMotiveId: string) {
		return this.list(`${ExemptionMotiveTypeService.baseEndpoint}/${exemptionMotiveId}`);
	}

	static getInstance() {
		return ExemptionMotiveTypeService.instance;
	}
}
